import Vue from 'vue'

let tawkLoaded = false;

const setPlayer = function(player, action) {
  let meta = {
    'name': player.username,
    'email': player.liveChatEmail,
    'hash': player.liveChatHash,
    'lastAction': action,
    'site': window.location.hostname
  };

  if (player.number) {
    meta.playerId = player.number;
    if (player.balance) {
      meta.realBalance = `${player.balance.real / 100} ${player.balance.currency}`;
      meta.bonusBalance = `${player.balance.bonus / 100} ${player.balance.currency}`;
      meta.hall = player.balance.branch;
    } else {
      meta.realBalance = 'no balance';
      meta.bonusBalance = 'no balance';
      meta.hall = 'unknown';
    }
  }

  Tawk_API.setAttributes(meta, e => e && console.log(e));
}

const tawk = function(player, action) {
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  if (tawkLoaded) {
    setPlayer(player, action);
  } else {
    Tawk_API.onLoad = () => {
      tawkLoaded = true;

      setPlayer(player, action);
    };

    (function () {
      var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = `https://embed.tawk.to/${player.liveChatCode}/default`;
      s1.charset = 'UTF-8';
      s1.language = Vue.state.lang.currentLang;
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    })();
  }
}

export default {
  async set(player, action) {
    if (!player.liveChatHash) return;

    tawk(player, action);
  }
}



// WEBPACK FOOTER //
// ./_common/services/livechat.service.js